const SOCIAL_META_ISSUE_KEYS = new Set([
  "metaDescription",
  "meta-description",
  "documentTitle",
  "document-title",
]);

const SOCIAL_META_TITLE_RE =
  /meta description|document does not have a meta description|document does not have a title|title element|open graph|og:|twitter:|social preview/i;

export function isSocialMetaRelatedIssue(issueKey, title = "") {
  if (issueKey && SOCIAL_META_ISSUE_KEYS.has(issueKey)) {
    return true;
  }

  return SOCIAL_META_TITLE_RE.test(title || "");
}
